import { atom } from 'recoil';

export const isNewVendorLoanModalOpenAtom = atom<boolean>({
  key: 'isNewVendorLoanModalOpenAtom',
  default: false,
});
